var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCocktail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.713867,
    y: 0.97168,
    width: 23.3155,
    height: 23.3156,
    rx: 3,
    fill: "#A7E497"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1416 0H4.85787C3.56992 0.00144251 2.33514 0.513718 1.42443 1.42444C0.513712 2.33515 0.00143994 3.56994 0 4.85788V20.1421C0.00143994 21.4301 0.513712 22.6648 1.42443 23.5756C2.33514 24.4863 3.56992 24.9986 4.85787 25H20.1416C21.4296 24.9986 22.6645 24.4863 23.5753 23.5756C24.4861 22.6649 24.9985 21.4301 25 20.1421V4.85788C24.9985 3.56988 24.4861 2.33508 23.5753 1.42438C22.6645 0.513667 21.4296 0.0014166 20.1416 0ZM23.057 20.1421C23.0561 20.915 22.7486 21.6559 22.202 22.2024C21.6555 22.7489 20.9145 23.0562 20.1416 23.057H4.85787C4.08507 23.0561 3.3442 22.7487 2.79775 22.2022C2.2513 21.6558 1.94389 20.9149 1.94296 20.1421V4.85788C1.94389 4.08509 2.2513 3.34421 2.79775 2.79776C3.3442 2.2513 4.08507 1.9439 4.85787 1.94296H20.1416C20.9145 1.94379 21.6555 2.25115 22.202 2.79761C22.7486 3.34407 23.0561 4.08501 23.057 4.85788V20.1421Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9765 6.70064C20.0922 6.54833 20.0922 6.39601 20.0151 6.2437C19.8993 6.09139 19.7065 6 19.5136 6H5.58826C5.35681 6 5.16394 6.09139 5.08679 6.2437C4.97107 6.39601 4.97107 6.57879 5.08679 6.70064L11.953 14.9865V19.4035H8.51991V20.3174H16.582V19.4035H13.1488V14.9865L19.9765 6.70064ZM12.5316 14.0116L8.71278 9.4118H16.3119L12.5316 14.0116ZM18.3949 6.91388L17.0834 8.49793H7.97987L6.66834 6.91388H18.3949Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktail);
export default __webpack_public_path__ + "static/media/cocktail.6de94ab1950207735d7bbaa75c8733a1.svg";
export { ForwardRef as ReactComponent };